const SettingsTopBanner = () => {
	const role = JSON.parse(localStorage.getItem('role'));

	const isActive = (url) => window.location.pathname === url;

	const urlList = {
		'restaurants': {
			label: 'Liste des restaurants',
			url: '/back-office/settings/restaurants/list',
		},
		'categories': {
			label: 'Liste des catégories',
			url: '/back-office/settings/categories/list',
		},
		'tva': {
			label: 'Liste des TVA',
			url: '/back-office/settings/tva/list',
		},
		'users': {
			label: 'Liste des utilisateurs',
			url: '/back-office/settings/users/list',
		},
		'restaurant-par-defaut': {
			label: 'Restaurant par défaut',
			url: '/back-office/settings/restaurant-par-defaut',
		},
		'delivery_zones': {
			label: 'Liste des frais de livraison',
			url: '/back-office/settings/delivery_zones/list',
		},
		'app-settings': {
			label: 'Paramètres de l\'application',
			url: '/back-office/settings/app-settings',
		},
		'referral-settings': {
			label: 'Paramètres de parrainage',
			url: '/back-office/settings/referral-settings',
		},
		...(role === 'super-admin' && {
			'audit-logs': {
				label: 'Logs d\'audit',
				url: '/back-office/settings/audit-logs',
			},
		}),
	}

	return (
		<>
			{role === 'super-admin' && <>
				<div class="overflow-hidden rounded-xl border border-gray-100 bg-gray-50 p-1">
					<ul class="bg-white grid grid-cols-2 gap-2 text-center gap-2 text-sm font-medium md:grid-cols-4">
						{Object.keys(urlList).map((key, index) => (
							<li key={index} className="flex-1">
								<a
									href={urlList[key].url}
									className={`text-primary relative flex items-center justify-center gap-2 rounded-lg px-3 py-2 shadow hover:bg-primary hover:text-white transition duration-300 ease-in-out ${isActive(urlList[key].url) ? 'bg-primary text-white' : ''}`}
								>
									{urlList[key].label}
								</a>
							</li>
						))}
					</ul>
				</div>
			</>
			}
		</>
	);
};

export default SettingsTopBanner;
